import { useTranslation } from 'react-i18next';
import { useEventNameConstructor, useSendEvents } from '../../core/hooks';
import { EVENTS as E, POLICY_LINK, SUPPORT_EMAIL, TERMS_LINK } from '../../core/constants';
import * as S from './styled';

const LINKS = { terms: TERMS_LINK, privacy: POLICY_LINK };

export const LegalFooter = ({ screenId = '', pb }: { screenId?: string; pb?: number }) => {
  const { t } = useTranslation();
  const sendEvents = useSendEvents({ screenId });
  const getEventName = useEventNameConstructor({ screenId });

  const onLinkClick = (type: keyof typeof LINKS) => {
    sendEvents(getEventName(E.CLICK), { [E.LR]: type });
    window.open(LINKS[type]);
  };

  return (
    <S.Footer className="ignore-inheritance" $pb={pb}>
      <S.Text>{t('footer_company_info')}</S.Text>
      <S.Text>{t('footer_copyright', { year: new Date().getFullYear() })}</S.Text>
      <S.Text>{t('footer_contact', { email: SUPPORT_EMAIL })}</S.Text>
      <S.Links>
        <S.Link type="button" id="link-to-terms" onClick={() => onLinkClick('terms')}>
          {t('terms')}
        </S.Link>
        <S.Link type="button" id="link-to-privacy" onClick={() => onLinkClick('privacy')}>
          {t('privacy')}
        </S.Link>
      </S.Links>
    </S.Footer>
  );
};
